import { doc, onSnapshot, Timestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import { fireStore } from "../../firebase";
import { useAppSelector } from "../storeHooks";

export const useOnUpdateEvent = (shouldStartUpdating: boolean, callback: () => void, eventId: string) => {
	const [eventUpdated, setEventUpdated] = useState<Timestamp | null>(null);
	const event = useAppSelector((state) => state.events.event);

	useEffect(() => {
		let unsubscribe: () => void;

		if (fireStore && eventId && !!event?.id && shouldStartUpdating) {
			const documentRef = doc(fireStore, "events", eventId);
			unsubscribe = onSnapshot(documentRef, (doc) => {
				if (doc.exists()) {
					setEventUpdated(doc.data().updatedAt);
				}
			});
		}
		return () => unsubscribe && unsubscribe();
	}, [shouldStartUpdating, eventId]);

	useEffect(() => {
		if (eventUpdated && shouldStartUpdating) {
			callback();
		}
	}, [eventUpdated, shouldStartUpdating, callback]);
};
